import { useMemo } from 'react'

import { isSupportNativeEmojiDisplay } from 'functions/emoji/support'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const useNativeEmoji = () => {
  const { osName, osVersion, browserName, browserVersion } =
    useShallowEqualSelector((state) => {
      const {
        systemReducer: { osName, osVersion, browserName, browserVersion },
      } = state
      return {
        osName,
        osVersion,
        browserName,
        browserVersion,
      }
    })
  return useMemo(
    () =>
      isSupportNativeEmojiDisplay(
        osName,
        osVersion!,
        browserName!,
        browserVersion!
      ),
    [osName, osVersion, browserName, browserVersion]
  )
}
